// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Response_Response__MF00n {
  display: flex;
  align-items: center;
  gap: 8px;
  width: fit-content;
}
.Response_Response__MF00n.Response_lg__210ed {
  padding: 10px 16px;
  border-radius: 500px;
  background-color: var(--white);
}
.Response_Response__MF00n.Response_lg__210ed span {
  font: var(--body-font-three);
}
.Response_Response__MF00n.Response_md__sy3Wj {
  padding: 6px 8px;
  border-radius: 500px 0 0 500px;
  background-color: var(--white);
}
.Response_Response__MF00n.Response_md__sy3Wj img {
  width: 16px;
  height: 16px;
}
.Response_Response__MF00n.Response_md__sy3Wj span {
  font: var(--body-font-four);
}
.Response_Response__MF00n.Response_sm__is\\+oN {
  padding: 6px 0;
}
.Response_Response__MF00n.Response_sm__is\\+oN img {
  width: 16px;
  height: 16px;
}
.Response_Response__MF00n.Response_sm__is\\+oN span {
  font: var(--body-font-four);
}
.Response_Response__MF00n img {
  width: 20px;
  height: 20px;
}
.Response_Response__MF00n span {
  font: var(--body-font-three);
  font-weight: 500;
  color: var(--primary-Text);
}
.Response_Response__MF00n.Response_very-responsive__U22-S span {
  color: var(--success);
  font-weight: bold;
}
.Response_Response__MF00n.Response_responsive__gRo5b span {
  color: var(--success-300);
}
.Response_Response__MF00n.Response_neutral__dZ6nN span {
  color: var(--brand);
}
.Response_Response__MF00n.Response_less-responsive__yTjhD span {
  color: var(--warning);
}
.Response_Response__MF00n.Response_unresponsive__xLaEW span {
  color: var(--error);
}`, "",{"version":3,"sources":["webpack://./src/components/atoms/Response/Response.module.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;AACD;AACC;EACC,kBAAA;EACA,oBAAA;EACA,8BAAA;AACF;AACE;EACC,4BAAA;AACH;AAGC;EACC,gBAAA;EACA,8BAAA;EACA,8BAAA;AADF;AAGE;EACC,WAAA;EACA,YAAA;AADH;AAIE;EACC,2BAAA;AAFH;AAMC;EACC,cAAA;AAJF;AAME;EACC,WAAA;EACA,YAAA;AAJH;AAOE;EACC,2BAAA;AALH;AASC;EACC,WAAA;EACA,YAAA;AAPF;AAUC;EACC,4BAAA;EACA,gBAAA;EACA,0BAAA;AARF;AAcE;EACC,qBAAA;EACA,iBAAA;AAZH;AAiBE;EACC,yBAAA;AAfH;AAoBE;EACC,mBAAA;AAlBH;AAuBE;EACC,qBAAA;AArBH;AA0BE;EACC,mBAAA;AAxBH","sourcesContent":[".Response {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tgap: 8px;\r\n\twidth: fit-content;\r\n\r\n\t&.lg {\r\n\t\tpadding: 10px 16px;\r\n\t\tborder-radius: 500px;\r\n\t\tbackground-color: var(--white);\r\n\r\n\t\tspan {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t}\r\n\t}\r\n\r\n\t&.md {\r\n\t\tpadding: 6px 8px;\r\n\t\tborder-radius: 500px 0 0 500px;\r\n\t\tbackground-color: var(--white);\r\n\r\n\t\timg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t}\r\n\r\n\t\tspan {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t}\r\n\t}\r\n\r\n\t&.sm {\r\n\t\tpadding: 6px 0;\r\n\r\n\t\timg {\r\n\t\t\twidth: 16px;\r\n\t\t\theight: 16px;\r\n\t\t}\r\n\r\n\t\tspan {\r\n\t\t\tfont: var(--body-font-four);\r\n\t\t}\r\n\t}\r\n\r\n\timg {\r\n\t\twidth: 20px;\r\n\t\theight: 20px;\r\n\t}\r\n\r\n\tspan {\r\n\t\tfont: var(--body-font-three);\r\n\t\tfont-weight: 500;\r\n\t\tcolor: var(--primary-Text);\r\n\t}\r\n\r\n\t//\r\n\r\n\t&.very-responsive {\r\n\t\tspan {\r\n\t\t\tcolor: var(--success);\r\n\t\t\tfont-weight: bold;\r\n\t\t}\r\n\t}\r\n\r\n\t&.responsive {\r\n\t\tspan {\r\n\t\t\tcolor: var(--success-300);\r\n\t\t}\r\n\t}\r\n\r\n\t&.neutral {\r\n\t\tspan {\r\n\t\t\tcolor: var(--brand);\r\n\t\t}\r\n\t}\r\n\r\n\t&.less-responsive {\r\n\t\tspan {\r\n\t\t\tcolor: var(--warning);\r\n\t\t}\r\n\t}\r\n\r\n\t&.unresponsive {\r\n\t\tspan {\r\n\t\t\tcolor: var(--error);\r\n\t\t}\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Response": `Response_Response__MF00n`,
	"lg": `Response_lg__210ed`,
	"md": `Response_md__sy3Wj`,
	"sm": `Response_sm__is+oN`,
	"very-responsive": `Response_very-responsive__U22-S`,
	"responsive": `Response_responsive__gRo5b`,
	"neutral": `Response_neutral__dZ6nN`,
	"less-responsive": `Response_less-responsive__yTjhD`,
	"unresponsive": `Response_unresponsive__xLaEW`
};
export default ___CSS_LOADER_EXPORT___;
